// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Avre","input":"styles_input__1Jh-U"};